export const USER_TOKEN_KEYS = [
  "sessionAuthToken",
];
